import { render, staticRenderFns } from "./ReleaseProjectInventoryModal.vue?vue&type=template&id=14287180"
import script from "./ReleaseProjectInventoryModal.vue?vue&type=script&lang=js"
export * from "./ReleaseProjectInventoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports